import React, { useState,useEffect } from 'react';
import './about-us.css'
import Beard from '../../assets/images/logo-beard2.svg'
import Footer from '../../layout/footer/footer'
import { Col } from 'react-bootstrap';
import {getAboutUs} from '../../utils/api'
import AboutUsIcon from '../../assets/images/about-us.png'
function AboutUs() {
    const [text , setText] = useState('')

    const getAboutUsData = async () => {
        try {
          let res = await getAboutUs()
          setText(res.data.data)
        } catch (error) {
    
        }
      }
      useEffect(() => {
        getAboutUsData()
      }, [])
    return (
        <>
            <div className='container'>
                <div className='d-flex align-items-center title gap-3'><img src={Beard} alt="" />درباره ما</div>


                <div className='text-[#001966] text-end mt-5 mb-5'>
                    <h5 className='font-bold'>
                        کادونا نسل جدید کارت‌های هدیه بانکی
                    </h5>
                </div>
                <div className="flex flex-wrap align-items-start flex-revers  color-changes"> 
                    <Col sm='12' md="8" className='text-end mt-5'>
                                       <p className='text-justify' dangerouslySetInnerHTML={{ __html: text}} />

                    </Col>
                    <Col sm='12' md="4">
                        <img src={AboutUsIcon} alt="" />
                    </Col>
                </div>



                {/* <div className='title text-end mt-5'>ویژگی‌های کارت هدیه کادونا</div>

                <div className="
                mt-3
                    flex
                    flex-wrap
                    gap-2
                    justify-center
                    [&_div]:bg-[white]
                    [&_div]:p-3
                    [&_div]:rounded-lg
                    [&_div]:border-[1px]
                    [&_div]:border-blue
                    [&_div]:text-blue
                    [&_div]:font-bold
                ">
                    <div className="item">شارژ با اپلیکیشن تاپ و کادونا</div>
                    <div className="item">قابلیت بهره برداری پس از 48 ساعت پس از شارژ</div>
                    <div className="item">امکان صدور از مبلغ 1 میلیون ریال تا 20 میلیون ریال برای اشخاص</div>
                    <div className="item">صدور آنی </div>
                    <div className="item">امکان خرید اینترنتی از تمام پذیرندگان مجازی</div>
                    <div className="item">قابلیت نقدشوندگی روزانه تا مبلغ 2 میلیون ریال از خودپردازهای بانک صادر کننده (پارسیان) </div>
                    <div className="item">تنوع طرح و شخصی سازی</div>
                    <div className="item">امکان خرید کالا و خدمات از گسترده ترین شبکه فروشگاهی و خدماتی طرف قرارداد با گروه فناوری دنا و بانک‌های عضو شتاب </div>
                    <div className="item"> امکان خرید اینترنتی کالا و خدمات و همچنین پرداخت قبوض، دریافت شارژ، خدمات گردشگری، هتل، بلیط قطار، اتوبوس، هواپیما و... از طریق دروازه پرداخت اینترنتی </div>
                </div> */}

            </div>
            <div className="home-footer mt-40">
                <Footer />
            </div>
        </>
    )
}

export default AboutUs